import { render, staticRenderFns } from "./FreeInputBehaviorEditor.vue?vue&type=template&id=4e65fc64&"
import script from "./FreeInputBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./FreeInputBehaviorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports